import React from 'react';
import UserPofileViewPage from './user-profile-view-page.component';

function UserProfilePage() {
    return <UserPofileViewPage isMyProfile={true} />
}

export default UserProfilePage;
